import axios from 'axios'
import NumberHelpers from './NumberHelpers'
import StringHelpers from './StringHelpers'
import DataHelpers from './DataHelpers'
import FirebaseHelpers from './FirebaseHelpers'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import Store from '../store/Store'
import ElementHelpers from './ElementHelpers'
import ContactHelpers from './ContactHelpers'
import Utilities from './Utilities'
import NiceData from '../data/NiceData';
import ArrayHelpers from './ArrayHelpers'
import AlgoliaHelpers from './AlgoliaHelpers'
import DateHelpers from './DateHelpers'
import Firestore from '../data/Firestore'
import Vue from 'vue'
import AlertHelpers from './AlertHelpers'
import CloudHelpers from './CloudHelpers'
import TeamHelpers from './TeamHelpers'




export default class {

    //New Functions for Firestore Contacts...
    static fetchRelationships(contact) { //returns promise
        const team = Firestore.getItemTeam(contact)
        const ref = Firestore.getCollectionDataRef(team, 'relationships').where('primaryId', '==', contact._id)
        return Firestore.fetchCollection(ref)
    }

    static contactPartnerId(contact) {
        const partnerRelationship = contact.relationships.find(o => o.relationship == 'Partner')
        if(partnerRelationship)
            return partnerRelationship.contactId
        else
            return null
    }

    static fetchCoupleRelationships(contact1, contact2) {
        return new Promise( (resolve, reject) => {
            const team = Firestore.getItemTeam(contact1)
            const ref1 = Firestore.getCollectionDataRef(team, 'relationships').where('primaryId', '==', contact1._id)
                .where('relatedId', '==', contact2._id)
            const ref2 = Firestore.getCollectionDataRef(team, 'relationships').where('primaryId', '==', contact2._id)
                .where('relatedId', '==', contact1._id)
            const p1 = Firestore.fetchCollection(ref1)
            const p2 = Firestore.fetchCollection(ref2)
            Promise.all([p1, p2]).then(results => {
                resolve([...results[0], ...results[1]])
            })                    
        })
    }

    static contactsArePartners(contact1, contact2) {
        return new Promise( (resolve, reject) => {
            this.fetchPartnershipRows(contact1, contact2).then(partnerships => {
                resolve(partnerships.length > 0)
            })
        })
    }

    static makePartners(contact1, contact2, relationships) {
        this.relateContacts(contact1, 'Partner', contact2, 'Partner', relationships)
    }

    static separatePartners(contact1, contact2, relationships) {
        let partnerRelationship = relationships.find(o => o.relatedRelationship == 'Partner')
        while(partnerRelationship) {
            Firestore.deleteObjectFromArray(partnerRelationship, relationships)
            Firestore.deleteItem(partnerRelationship)
            partnerRelationship = relationships.find(o => o.relatedRelationship == 'Partner')
        }


        this.saveHasPartnerTag(contact1, null)
        this.saveHasPartnerTag(contact2, null)

        console.log('Separated...')

    }

    static relateContacts(contact1, relationship1, contact2, relationship2, relationships) {

        const t1 = Firestore.getItemTeam(contact1)
        const t2 = Firestore.getItemTeam(contact2)

        if(t1 != t2)
            throw('Cannot relate contacts from different teams')

        const r1 = {
            _id: Firestore.getId(),
            _team: t1,
            _collection: 'relationships',
            name: contact1.firstName + ' and ' + contact2.firstName,
            primaryId: contact1._id,
            primaryFirstName: contact1.firstName,
            primaryLastname: contact1.lastName,
            relatedId: contact2._id,
            relatedRelationship: relationship2,
            relatedFirstName: contact2.firstName,
            relatedLastName: contact2.lastName,
            relatedImage: contact2.image,
        }

        const r2 = {
            _id: Firestore.getId(),
            _team: t1,
            _collection: 'relationships',
            name: contact2.firstName + ' and ' + contact1.firstName,
            primaryId: contact2._id,
            primaryFirstName: contact2.firstName,
            primaryLastname: contact2.lastName,
            relatedId: contact1._id,
            relatedRelationship: relationship1,
            relatedFirstName: contact1.firstName,
            relatedLastName: contact1.lastName,
            relatedImage: contact1.image,
        }

        relationships.push(r1)
        relationships.push(r2)
        Firestore.saveItem(r1)
        Firestore.saveItem(r2)

        //If partners, flag the contacts
        if(relationship1 == 'Partner') {
            this.saveHasPartnerTag(contact1, true)
            this.saveHasPartnerTag(contact2, true)
        }

        console.log('Related contacts')
    }

    static saveHasPartnerTag(contact, value) {
        Vue.set(contact, 'hasPartner', value)
        Firestore.saveItem(contact)
    }

    //Legacy Contact Functions for Realtime DB

    static mergeContactCards(role,elements) {
        const matchingElements = ElementHelpers.contactElementsForRole(role, elements)
        let str = ''
        matchingElements.forEach(element => {
            str += this.contactCard(element.contact)
        })
        return str
    }

    static contactCard(contact) {
        let img = contact.image || ''
        let initials = ''
        if(img.indexOf('random') > -1)
            img = ''
        if(!img)
            initials = ContactHelpers.initials(contact)
        let str = `
        <table>
            <tr>
                <td rowspan="2" valign="top" style="padding:0 10px">
                    <div style="background-color:#03a9f4;background-image:url(${img});border-radius:25px;width:50px;height:50px;border:solid 2px #eee;background-size: cover;background-position: center center;background-repeat: no-repeat;font-size:20px;color:white;padding:6px 10px;">${initials}</div>
                </td>
                <td style="background-color:#ddd;border-radius:5px;padding:3px 10px;font-weight:bold;border:solid 1px #bbb;" >
                    ${ContactHelpers.fullName(contact)}
                </td>
            </tr>
            <tr>
                <td>
                    [contact_details]
                </td>
            </tr>
        </table>`
        return str.replace('[contact_details]', this.contactDetails(contact))
    }

    static contactDetails(contact) {
        let str = '<table>'
        str = this.addDetail(str, 'M', StringHelpers.formatPhone(contact.mobile))
        str = this.addDetail(str, 'T', StringHelpers.formatPhone(contact.phone))
        str = this.addDetail(str, 'E', StringHelpers.formatMailTo(contact.email) )
        str = str + '</table>'
        return str
    }

    static addDetail(str, heading, value) {
        if(!value)
            return str
        str += `
        <tr style="">
            <td style="color:#888;font-weight:bold;margin-right:10px;width:1%;text-align:right;padding-right:5px;">${heading}</td>
            <td style="color:#555">${value}</td>
        </tr>`
        return str
    }

    static namesToContacts(nameString) {
        if(!nameString)
            return []

        let contacts = []
        let previousLastName = ''
        nameString = nameString.replace(/ and /gi, ',').replace(/ \& /, ',')
        let fullNames = nameString.split(',')
        fullNames.reverse()
        fullNames.forEach(fullName => {
            let names = fullName.trim().split(' ')
            let lastName = names[names.length - 1].trim()

            if(names.length > 2) {
                
                let middleName = names[names.length - 2]
                if(ArrayHelpers.textInArray(middleName, ['Mc', 'Mac', 'Van', 'Von']))
                    lastName = middleName + ' ' + lastName
            }


            if(names.length < 2)
                lastName = previousLastName || ''
            else
                previousLastName = lastName

            let firstName = fullName.replace(lastName, '').trim()
            contacts.unshift({firstName, lastName})
        })
        return contacts
    }
    
    static async setInitialGender (model) {
        let vm = this

        
        if(!model.firstName || model.firstName.length < 3 || model.gender)
            return
        
        console.log('gender check')

        model.gender = await CloudHelpers.getGender(model.firstName)
        model.image = this.getGenderImage(model.gender)
    }

    static getGenderImage(gender) {
        let menWomen = (gender == 'Male' ? 'men' : 'women')
        let randomNumber = NumberHelpers.randomInt(99)
        return `https://randomuser.me/api/portraits/${menWomen}/${randomNumber}.jpg`
    }

    static getGender (firstName) {
        return CloudHelpers.getGender(firstName)
    }

    static getSampleImage (gender) {
        
        if(!gender)
            return ''

        let menWomen = (gender == 'Male' ? 'men' : 'women')
        let randomNumber = NumberHelpers.randomInt(99)
        return `https://randomuser.me/api/portraits/${menWomen}/${randomNumber}.jpg`        
    }

    static getContactImage(contact, blankAvatars) {

        if(blankAvatars && contact.image && contact.image.indexOf('random') > -1) {
            const gender = contact.gender || 'Male'
            return `/static/images/${gender}.jpg`
        }
            
        else
            return contact.image

    }

    static simplifyContact (sourceContact) {
        if(!sourceContact)
            return null

        let contact = {
            firstName: sourceContact.firstName || '',
            preferredName: sourceContact.preferredName || '',
            lastName: sourceContact.lastName || '',
            gender: sourceContact.gender || '',
            email: sourceContact.email || '',
            fax: sourceContact.fax || '',
            mobile: sourceContact.mobile || '',
            phone: sourceContact.phone || '', 
            image: sourceContact.image || '',
            address: sourceContact.address || '',
            dob: sourceContact.dob || '',
            middleName: sourceContact.middleName || '',
            notes: sourceContact.notes || '',
            openedAt: DateHelpers.nowString(),
        }
        return contact
    }

    static createFaxContact(contact) {
        let faxContact = {...contact}
        faxContact.key = faxContact.key + 'f'
        faxContact.email = Utilities.toFaxAddress(contact.fax)
        faxContact.fullName = faxContact.fullName || this.fullName(contact) + ' (Fax)'
        return faxContact
    }

    static saveContact (contactToSave) {

        let contact = {...contactToSave}

        console.log('ContactHelpers > saveContact')

        let vm = this
        let tenantKey =  NiceData.safelyGetTenant(contact)
        let key = NiceData.safelyGetKey(contact)
        let isExisting = true

        // Get contact key or make one
        if(!key) {
            isExisting = false
            //key = firebase.database().ref().push().getKey()
            key = DataHelpers.getKey()
        }

        delete contact['.key']
        delete contact['key']
        delete contact['role']
        delete contact['meta']
        //delete contact.owner['meta']

        contact.tenantKey = contact.tenantKey || tenantKey  //since 7/18 added tenant TO REMOVE AGAIN

        let me = Store.getters.user

        if(!contact.owner) {
            contact.owner = {
                key: me.uid,
                firstName: me.firstName,
                lastName: me.lastName
            }
        }

        this.formatMobileForContact(contact)

        let tenantRef = firebase.database().ref('tenants/' + tenantKey)

        // Save or update this contact

        tenantRef.child('contacts').child(key).update(contact)

        let simpleContact = this.simplifyContact(contact)

        //Algolia...

        this.saveToAlgolia({...contact, key, tenantKey})

        // // Do recent contacts...
        // const recentContact = {...contact, key:key}
        // Store.commit('addRecentContactForUser', recentContact)

        if(!isExisting) {
            return
        }

        // Existing Contact updates below

        // Do partner
       

        tenantRef.child('contacts').child(key).once('value', function (snap) {
            const dbContact = snap.val()
            if(dbContact.partner) {
                const partnerKey = dbContact.partner.key
                tenantRef.child('contacts').child(partnerKey).child('partner').update({...simpleContact, key: key})
            }
        })

        // Do people in transactions
        tenantRef.child('contactTransactions').child(key).on('child_added', function (snap) {
            console.log('Updating contacts in transaction', snap.key)

            let transactionRef = tenantRef.child('transactions').child(snap.key)
            
            // //todo: remove old way
            // transactionRef.child('people').child(key).update(simpleContact)
                        
            //new way
            transactionRef.child('elements').orderByChild('contactKey').equalTo(key).once('value', elSnap => {
                elSnap.forEach(elementSnap => {
                    transactionRef.child('elements').child(elementSnap.key).child('contact').update(simpleContact)
                    vm.updateContactInStore(elementSnap.key, simpleContact)
                })
            })

            
        })

    }

    static saveToAlgolia(contact) {
        let algoliaObj = this.contactToAlgoliaContact(contact)

        AlgoliaHelpers.saveToIndex('contacts_' + contact.tenantKey, algoliaObj) 
    }

    static saveListToAlgolia(arr) {
        const output = []
        arr.forEach(contact => {
            output.push(this.contactToAlgoliaContact(contact))
        })
        console.log('output is ', output)
        AlgoliaHelpers.saveListToIndex('contacts_' + DataHelpers.getTenantKey(), output)
    }

    static contactToAlgoliaContact(contact) {
        let a = {...contact}
        a.objectID = NiceData.safelyGetKey(contact)
        a.initials = this.initials(contact)
        a.tenantKey = NiceData.safelyGetTenant(contact)
        // if(contact.partner && contact.partner.firstName) {
        //     a.partner = {
        //         firstName: contact.partner.firstName,
        //         lastName: contact.partner.lastName,
        //         key: contact.partner.key,
        //     }
        // }   
        // delete a.groups
        // delete a.gender
        // delete a.owner
        // delete a.office
        // delete a.uid
        // delete a.user
        return a
    }

    static updateOpenedDate(item) {
        setTimeout( () => {
            let savePath
            let key
            if(item.meta && item.meta.key) {
                savePath = item.meta.path
                key = item.meta.key
            }
            else if(item.key) {
                key = item.key
                savePath = 'tenants/' + item.tenantKey + '/contacts'
            }
            else if(item.objectID) {
                key = item.objectID
                savePath = 'tenants/' + item.tenantKey + '/contacts'
            }
            let ref = DataHelpers.getRootRef().child(savePath).child(key)
            ref.update({'openedAt': DateHelpers.nowString()})
        },200)
    }


    static formatMobileForContact(contact) {   //mutates contact object
        if(contact && contact.mobile) {
            contact.mobile = contact.mobile.replace(/\D/g,'')
            contact.mobileSearch = contact.mobile.substr(contact.mobile.length - 3)
        }
    }

    static updateContactInStore(key, contact) {
        const elements = Store.getters.elements
        if(!elements)
            return

        const element = elements.find(o => o.key == key)
        if(!element)
            return
        
        element.contact = Object.assign(element.contact, contact)
        Store.commit('saveElement', element)
    }

    static deleteContact (contact) {
        console.log('ContactHelpers > deleteContact')

        if(contact.user) {
            AlertHelpers.showAlert('Cannot delete a user record')
            return
        }

        if(!contact.meta) {
            console.error('no meta in deletecontact')
            debugger
            return
        }
            
        let tenantKey = contact.meta.tenantKey
        let key = contact.meta.key

        let tenantRef = firebase.database().ref('tenants/' + tenantKey)
        tenantRef.child('contacts').child(key).remove()
    }

    static cacheContact(contact) {
        setTimeout(() => {
            let recent = {tenantKey: DataHelpers.getTenantKey(), key: contact.key}
            Store.commit('addRecentContactForUser', recent)
        },1500)
    }

    static linkContact(transactionKey, contact, role) {
        console.log('linkContact', contact, role)
        let newElement = {}
        newElement.type = 'Contact'
        newElement.role = role
        newElement.title = role

        newElement.name = StringHelpers.toSnakeCase(role)
        newElement.contact = FirebaseHelpers.cloneWithoutKey(contact)
        newElement.value = ContactHelpers.fullName(contact)
        newElement.contactKey = contact.meta.key
        newElement.transactionKey = transactionKey
        ElementHelpers.saveElement(newElement)
        return newElement
    }

    static replaceContact(transactionKey, contact, role, elements) {
        let existingElement = ElementHelpers.singleContactElementForRole(role, elements)
        if(!existingElement) {
            existingElement = this.linkContact(transactionKey, contact, role)
            return existingElement
        }
        existingElement.contact = ContactHelpers.simplifyContact(contact)
        existingElement.value = ContactHelpers.fullName(contact)
        existingElement.contactKey = contact.key
        ElementHelpers.saveElement(existingElement)
        return existingElement
    }

    static fetchTransactionContactElement(transactionKey, contactKey) {
        return new Promise( (resolve, reject) => {
            if(!transactionKey) {
                console.error('fetchTransactionContactElement > No transaction key')
                reject('No transaction key')
            }
            if(!contactKey) {
                console.error('fetchTransactionContactElement > No contact key')
                reject('No contact key')
            }
            let ref = DataHelpers.getTenantRef().child('transactions').child(transactionKey).child('elements')
            ref.orderByChild('contactKey').equalTo(contactKey).once('value', (snap) => {
                const elements = FirebaseHelpers.snapshotToArray(snap)
                if(!elements.length)
                    resolve(null)
                else
                    resolve(elements[0])
            })
        })

    }

    static unlinkContact(transactionKey, contactKey) {
        console.log('ContactHelpers > unlinkContact (t,c)', transactionKey, contactKey)
        
        let tenantKey = Store.getters.tenantKey

        let tenantRef = firebase.database().ref('tenants/' + tenantKey)

        tenantRef.child('contactTransactions').child(contactKey).child(transactionKey).remove()  
        tenantRef.child('transactions').child(transactionKey).child('people').child(contactKey).remove()     
    }

    static loadingContact() {
        return {
            key: 0,
            '.key': 0,
            firstName: 'Loading',
            lastName: '',
            image: '/static/images/loader-basic.gif'
        }
    }

    // Firebase user to contact

    static contactFromUser (usr) {

        let contact = {
            email: usr.email || null,
            mobile: usr.mobile || null,
            image: usr.photoURL || null,
            uid: usr.uid || null
        }
        
        let namesArr = usr.displayName.split(' ')
        contact.firstName = namesArr[0] || null
        contact.lastName = namesArr[1] || null

        return contact
    }

    static fullName (contact) {
        if(!contact)
            return ''

        let name = (contact.firstName || '') + (contact.firstName && contact.lastName ? ' ' : '') + (contact.lastName || '')
        
        if(!name)
            name = contact.business
        
        return name
    }

    static phoneNumbers (contact) {
        if(!contact)
            return ''

        return (this.formatMobile(contact.mobile) || '') + (contact.mobile && contact.phone ? ', ' : '') + (contact.phone || '')
    }

    static bestNumber (contact) {
        if(!contact)
            return ''

        if(contact.mobile)
            return (this.formatMobile(contact.mobile) || '') 
            
        if(contact.phone)
            return (contact.phone || '')
    }

    static formatMobile(mobile) {
        if(!mobile)
            return ''
        mobile = mobile.replace(/\D/g,'')
        return mobile.substr(0,4) + ' ' + mobile.substr(4,3) + ' ' + mobile.substr(7)
    }

    static initials (contact) {
        
        if(!contact)
            return ''

        return (contact.firstName ? contact.firstName.charAt(0) : '?') + (contact.lastName ? contact.lastName.charAt(0) : '?')
    }

    static combineClientsNames(clients) {
        
        if(!clients || !clients.length) {
            console.log('combineClientsNames was passed nothing')
            return ''
        }
        
        if(clients.length == 1)
            return this.fullName(clients[0])
        if(clients.length == 2) {
            if(clients[0].lastName == clients[1].lastName)
                return clients[0].firstName + ' and ' + clients[1].firstName + ' ' + clients[0].lastName
            else
                return this.fullName(clients[0]) + ' and ' + this.fullName(clients[1])
        }
        return StringHelpers.sentenceJoin(clients.map(o => o.firstName))
    }

    static contactDetailsToText(contact) {
        let str = this.fullName(contact)
        if(contact.mobile)
            str += ' ' + contact.mobile
        if(contact.email)
            str += ' ' + contact.email
        return str
    }

    static greetingFromContacts(contactsArray) {
        if(!contactsArray || !contactsArray.length)
            return ''
            
        let preferredNameArray = contactsArray.map(o => {
            return o.preferredName || o.firstName
        }).filter(item => item)
        return StringHelpers.sentenceJoin(preferredNameArray)
    }

    static getUsers () {
        return new Promise(function(resolve, reject) {
            let tenantKey = Store.getters.tenantKey
            let users = []
            
            let ref = firebase.database().ref('tenants').child(tenantKey).child('contacts').orderByChild('user').equalTo(true)
            let vm = this
            
            ref.once('value', function(snap){
                snap.forEach(function(item){
                    let user = {
                        uid: item.key,
                        firstName: item.val().firstName,
                        lastName: item.val().lastName,

                        //TODO: remove name later
                        name: item.val().firstName + ' ' + item.val().lastName,
                        email: item.val().email,
                        image: item.val().image
                    }
                    users.push(user)
                })
                users = users.sort((a,b) => a.name > b.name)
                resolve(users)
            })            
        })
    }  

    static fetchUsersForOffice(officeKey) {
        return new Promise( (resolve, reject) => {
            if(!officeKey)
                resolve([])
            let ref = DataHelpers.getRootRef().child('tenants').child(officeKey).child('contacts').orderByChild('user').equalTo(true)        
            
            ref.once('value', snap => {
                let users = NiceData.arrayFromSnapshot(snap)
                resolve(users)
            })
        })
    }
    
    static capitalizeForSearching(term) {
        term = StringHelpers.capitalizeFirstLetter(term)
        
        //handle Mc where third letter is capitalised
        if(term.substr(0,2) == 'Mc') {
            let newChar = term.charAt(2).toUpperCase()
            term = StringHelpers.replaceAt(term, 2, newChar)
        }
        return term
    }

    static searchNames (term) {

        // if(term == term.toUpperCase()) //this breaks searching for banks
        //     term = term.toLowerCase()

        let names = term.split(' ').sort(function (a, b) { return b.length - a.length; })
        //console.log('search > names', names)
        let primaryName = this.capitalizeForSearching(names[0])
        //console.log('search > primaryName', primaryName)
        
        let secondaryName = ''
        if(names.length > 1)
            secondaryName = this.capitalizeForSearching(names[1]) 

        return {primaryName, secondaryName}
    }

    static isMobileSearch(str) {
        let result =  (str && str.length == 3 && NumberHelpers.isNumeric(str))
        return result
    }

    static searchAnalysis(term) {
        if(!term)
            return {type: 'recent'}
        if(term.length < 3)
            return {type: 'waiting'}
        if(term && term.length == 3 && NumberHelpers.isNumeric(term))
            return {type: 'mobile', search: term}

        let result = this.searchNames(term)
        result.type = 'names' 
        return result
    }

    static fetchContactByEmail(email) {
        return new Promise( (resolve, reject) => {
            let ref = DataHelpers.getTenantRef().child('contacts').orderByChild('email').equalTo(email)        
            ref.once('value', snap => {
                let contacts = NiceData.arrayFromSnapshot(snap)
                
                if(contacts.length < 1) {
                    const err = 'fetchContactByEmail fails...no contact found with email ' + email
                    console.log(err)
                    reject(err)
                } else if(contacts.length > 1) {
                    const err = 'fetchContactByEmail fails...multiple contacts found with email ' + email
                    console.log(err)
                    reject(err)
                } else {
                    resolve(contacts[0])
                }

            })
        })
    }

    static fetchContact(key) {
        return new Promise( (resolve, reject) => {
            let ref = DataHelpers.getTenantRef().child('contacts').child(key) 
            NiceData.fetchItemSingle(ref).then(contact => {
                resolve(contact)
            })
        })
    }

    static copyTransactionContactToOffices(transactionContact, officeKey) {
        const newTransactionContact = {...transactionContact}
        const fromKey = transactionContact.tenantKey
        const newPath = 'tenants/' + transactionContact.tenantKey +
                        '/transactions/' + transactionContact.transactionKey + 
                        '/elements'
        const newKey = transactionContact.key
        newTransactionContact.tenantKey = officeKey
        delete newTransactionContact['key']
        delete newTransactionContact['.key']
        newTransactionContact.meta = {
            path:newPath,
            key:newKey
        }

        NiceData.saveItem(newTransactionContact)

        let contactRef = DataHelpers.getTenantRef(fromKey).child('contacts').child(transactionContact.contactKey)
        NiceData.fetchItemSingle(contactRef).then(contact => {
            const newContact = {...contact}
            newContact.meta.path = contact.meta.path.replace(fromKey, officeKey)
            NiceData.saveItem(newContact)
        })
    }
    static checkForDuplicates(firstName, lastName) {
        return new Promise( (resolve, reject) => {
            const ref = DataHelpers.getTenantRef().child('contacts')
                .orderByChild('lastName').equalTo(lastName)
            NiceData.fetchItemsFromFirebase(ref).then(contacts => {
                let match = contacts.find(o => o.firstName == firstName)
                if(match)
                    resolve(match)
                else
                    resolve(false)
            })
        })
    }


}




// WEBPACK FOOTER //
// ./src/helpers/ContactHelpers.js